import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VacancyModerationEvents } from '@common/model/admin/vacancyModeration/events';
import { authenticationTokenSelector } from '@cp/shared/api/core';
import { useSocketManager } from '@cp/shared/api/socket';
import { AdminCatalogItemApiTag, adminCatalogItemApi } from 'src/entities/catalog/item';

export const useVacancyModerationRealtime = (): void => {
  const dispatch = useDispatch();
  const authToken = useSelector(authenticationTokenSelector);
  const manager = useSocketManager();
  const socket = useMemo(() => manager.socket('/vacancy-moderation', { auth: { token: authToken } }), [authToken, manager]);

  useEffect(() => {
    if (authToken && !socket.connected) {
      socket.connect();
    }
  }, [socket, authToken]);

  useEffect(() => {
    const handleUpdate = () => {
      dispatch(adminCatalogItemApi.util.invalidateTags([{ type: AdminCatalogItemApiTag.ItemList }]));
    };

    socket.on(VacancyModerationEvents.Updated, handleUpdate);

    return () => {
      socket.off(VacancyModerationEvents.Updated, handleUpdate);
    };
  }, [dispatch, socket]);
};
